var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","color":"error","small":"","loading":_vm.loading},on:{"click":_vm.confirmRemove}},[_vm._v("Delete Device")])
}
var staticRenderFns = []

export { render, staticRenderFns }